import { createContext } from 'react';

import { AuthContextType } from '@/types/types';

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export default AuthContext;
